// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var orderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/list',
  name: 'Order',
  alwaysShow: true,
  meta: {
    title: '订单',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '订单'
    }
  }, {
    path: 'refund',
    component: function component() {
      return import('@/views/order/refund/index');
    },
    name: 'refund',
    meta: {
      title: '退款订单'
    }
  }, {
    path: 'funpay',
    component: function component() {
      return import('@/views/order/funpay/index');
    },
    name: 'FunPayMer',
    meta: {
      title: 'FunPay订单推送记录'
    }
  }, {
    path: 'reservation',
    component: function component() {
      return import('@/views/order/reservation/index');
    },
    name: 'OrderReservation',
    meta: {
      title: '预约',
      icon: ''
    },
    children: [{
      path: 'service',
      component: function component() {
        return import('@/views/order/reservation/service');
      },
      name: 'Service',
      meta: {
        title: '预约看板',
        icon: ''
      }
    }, {
      path: 'workOrder',
      component: function component() {
        return import('@/views/order/reservation/workOrder');
      },
      name: 'WorkOrder',
      meta: {
        title: '工单管理',
        icon: ''
      }
    }]
  }, {
    path: 'supply',
    name: 'OrderSupply',
    component: function component() {
      return import('@/views/order/supply/index');
    },
    redirect: 'noRedirect',
    meta: {
      title: '供应链',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'orderRecord',
      component: function component() {
        return import('@/views/order/supply/orderRecord');
      },
      name: 'SupplyOrderRecord',
      meta: {
        title: '下单记录'
      }
    }, {
      path: 'afterSalesRecord',
      component: function component() {
        return import('@/views/order/supply/afterSalesRecord');
      },
      name: 'SupplyAfterSalesRecord',
      meta: {
        title: '售后记录'
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/order/supply/list');
      },
      name: 'SupplyOrderList',
      meta: {
        title: '订单管理'
      }
    }]
  }]
};
export default orderRouter;